import { render } from "./EventModalLowerInfoBox.vue?vue&type=template&id=581a4f59&scoped=true"
import script from "./EventModalLowerInfoBox.vue?vue&type=script&lang=js"
export * from "./EventModalLowerInfoBox.vue?vue&type=script&lang=js"

import "./EventModalLowerInfoBox.vue?vue&type=style&index=0&id=581a4f59&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-581a4f59"]])

export default __exports__